import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { addOrderItem, sortPartRequest } from "../../../../../../actions/course-author/common";
import { OrderItemsComponent } from "./OrderItems.component";
import { IOrderItemsDispatchProps } from "./OrderItems.types";

const mapDispatchToProps = (dispatch: Dispatch): IOrderItemsDispatchProps =>
  bindActionCreators({ addOrderItem, sortPartRequest }, dispatch);

export const OrderItems = connect(null, mapDispatchToProps)(OrderItemsComponent);
